import React, { useState, useEffect } from "react";
import s from "./Juegos.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { gameOffersUpdate } from "../../../store/slices/gammaSlice";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { dateFormats } from "../../../helpers/convertDate";
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import ToggleButton from "@mui/material/ToggleButton"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import Button from "@mui/material/Button"
import TableCell from "@mui/material/TableCell"
import TableBody from "@mui/material/TableBody"
import TableRow from "@mui/material/TableRow"
import Avatar from "@mui/material/Avatar"
import CircularProgress from "@mui/material/CircularProgress"
import CasinoIcon from "@mui/icons-material/Casino";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import CreateGame from "./Create";
import HandleRequests from "../../Shared/handleRequests/HandleRequests";
import gamesService from "../../../api/games/GamesService";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import Pager from "../../Shared/Pagination/Pagination";
import useTranslationException from "../../../helpers/exceptions";

// ========================== | JUEGOS | ======================================

export const Juegos = () => {
  const dates = dateFormats();

  const dispatch = useDispatch();
  const [display, setDisplay] = useState("list");
  const { textColor } = useSelector((state) => state.local);
  const backError = useSelector((state) => state.errors.gamesError);
  const [games, setGames] = useState(null);
  const [edit, setEdit] = useState({
    game: {},
    status: false,
  });

  //pagination
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [manualPagination, setManualPagination] = useState(page);
  const [sort, setSort] = useState({ criteria: "DESC", field: "id" });

  const navigate = useNavigate();
  const location = useLocation();

  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);

  const newGame = () => {
    let path = "./create";
    navigate(path);
  };

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  const getGames = () => {
    setLoading(true);
    gamesService
      .getGameOffers(
        page,
        perPage,
        null,
        sort,
      )
      .then((res) => {
        setTotalPages(res.totalPages);
        setGames(res.content);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    getGames();
  }, [page, perPage, sort]);

  const handleDelete = (item) => {
    console.log("handleDelete", item);
    Swal.fire({
      title: `Eliminar ${item.modality.game.name} de ${item.modality.game.lottery.name}`,
      text: "Está accion no se puede revertir, puede editarlo si desea en el icono de lapiz.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        gamesService
          .deleteGameOffers(item.id)
          .then((response) => {
            gamesService.deleteBaseGame(item?.modality?.game?.id).then(() => {
              gamesService
                .getGameOffers(1)
                .then((res) => {
                  setTotalPages(res.totalPages);
                  setGames(res.content);
                  dispatch(gameOffersUpdate(res));
                  Swal.fire(
                    "Borrado",
                    "El juego ha sido eliminado.",
                    "success",
                  );
                });
            });
          });
      }
    });
  };

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  return location.pathname.includes("create") ? (
    <CreateGame
      games={games}
      getGames={getGames}
      edit={edit}
      setEdit={setEdit}
    />
  ) : (
    <Grid container className={s.container}>
      <HandleRequests error={backError} loading={!games}>
        <Grid item container xs={11} className={s.header}>
          <Grid item lg={3} md={6} xs={10} className={s.titleContainer}>
            <CasinoIcon sx={{ fontSize: "2rem", color: "primary.main" }} />
            <h4>{t("games")}</h4>
            <Button variant="contained" className={s.add_btn} onClick={newGame}>
              {t("add")}
            </Button>
          </Grid>
          {/* <Grid item lg={7} md={8} xs={12} my={2}>
          <GamesSearch item={games} setItems={setGames} setLoading={setLoading} setTotalPages={setTotalPages} setSearching={setSearching} searching={searching}/>
        </Grid> */}
          <Grid item lg={1.5} md={3} xs={10} className={s.displayItem}>
            <ToggleButtonGroup
              size="small"
              color="primary"
              exclusive
              value={display}
              onChange={(e, v) => setDisplay(v)}
            >
              <ToggleButton value="list">
                <ViewListIcon
                  sx={{ fontSize: "1.3rem", color: "primary.main" }}
                />
              </ToggleButton>
              <ToggleButton value="module">
                <ViewModuleIcon
                  sx={{ fontSize: "1.3rem", color: "primary.main" }}
                />
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </Grid>

        {display === "module" ? (
          <Grid item xs={11} className={s.gamesContainer}>
            {loading ? (
              <CircularProgress size={"4rem"} />
            ) : (
              games?.map((g, i) => (
                <React.Fragment key={i}>
                  <Box
                    key={i}
                    className={`${s.itemGame} ${g.enabled ? null : s.disabledGame}`}
                  >
                    <Box
                      className={s.data}
                      sx={{
                        color: "primary.dark",
                        background:
                          "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6), rgba(255,255,255,0), rgba(255,255,255,0))",
                      }}
                    >
                      <h4>{g.modality.game?.name}</h4>
                      <p>{g.modality.game?.lottery.name}</p>
                      <Box className={s.options}>
                        <p>{g.enabled ? t("active") : t("inactive")}</p>
                        <Box className={s.icons}>
                          <EditRoundedIcon
                            className={s.icon}
                            sx={{ color: "primary.dark" }}
                            onClick={() => {
                              setEdit({ game: g, status: true });
                              newGame();
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>
                    <img
                      src={g.modality.game?.image}
                      alt={g.modality.game?.name}
                      className={s.gameBackground}
                    />
                  </Box>
                </React.Fragment>
              ))
            )}
          </Grid>
        ) : (
          <Grid item xs={11} className={s.dataContainer}>
            {loading ? (
              <CircularProgress size={"4rem"} />
            ) : (
              <TableContainer className={s.tableContainer}>
                <Table className={s.table} stickyHeader>
                  <TableHead className={s.tableHead}>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("logo")}
                      </TableCell>
                      <TableCell
                        sx={{
                          cursor: "pointer",
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("id")}
                      >{`${t("name")} ${sort.field === "id" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                      <TableCell
                        sx={{
                          cursor: "pointer",
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("modality")}
                      >{`${t("modality")} ${sort.field === "modality" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                      <TableCell
                        sx={{
                          cursor: "pointer",
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("enabled")}
                      >{`${t("state")} ${sort.field === "enabled" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                      <TableCell
                        sx={{
                          cursor: "pointer",
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("creationDate")}
                      >{`${t("dischargeDate")} / ${t("modify")} ${sort.field === "creationDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("edit")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {games?.map((g, i) => (
                      <React.Fragment key={i}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            <Avatar
                              src={g.modality?.game?.image}
                              sx={{ width: "3rem", height: "3rem" }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {g.modality?.game?.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {g.modality?.mode?.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {g.enabled ? t("active") : t("inactive")}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {g.lastModificationDate
                              ? dates.formatDate(g.lastModificationDate)
                              : dates.formatDate(g.dateCreate) || "-"}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            <EditRoundedIcon
                              className={s.iconbtn}
                              sx={{ color: "primary.dark" }}
                              onClick={() => {
                                setEdit({ game: g, status: true });
                                newGame();
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        )}
      </HandleRequests>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: "50px",
        }}
      >
        <Pager
          pageSize={perPage}
          setPageSize={setPerPage}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={manualPagination}
          setPageCustom={setManualPagination}
        />
      </Grid>
    </Grid>
  );
};
